import { createFeatureSelector, createSelector } from '@ngrx/store';

import { INTELLISENSE_FEATURE_KEY } from './intellisense.reducer';
import { type IntellisenseState } from './intellisense.state';

export const getIntellisenseState =
  createFeatureSelector<IntellisenseState>(INTELLISENSE_FEATURE_KEY);

export const selectContext = createSelector(getIntellisenseState, (state) => state.context);

export const selectContextVars = createSelector(selectContext, (state) => state.vars);
